import { toastService } from "../../../libraries/toast";
import { menstrualCycleService } from "../entity/MenstrualCycleService";

export const updateMenstrualCycleUseCase = async (
    old_category_item_ids: number[],
    new_category_item_ids: number[],
    recommended_type: string,
) => {
    try {
        const toAdd = new_category_item_ids.filter(id => !old_category_item_ids.includes(id));
        const toRemove = old_category_item_ids.filter(id => !new_category_item_ids.includes(id));

        const [responseAdd, responseRemove] = await Promise.all([
            toAdd.length
                ? menstrualCycleService.addRecommendations({ recommended_type, category_item_ids: toAdd })
                : Promise.resolve({ isError: false }),
            toRemove.length
                ? menstrualCycleService.removeRecommendations({ recommended_type, category_item_ids: toRemove })
                : Promise.resolve({ isError: false }),
        ]);

        if (responseAdd?.isError || responseRemove?.isError) {
            toastService.onError('Some error');
        } else {
            return { isError: false };
        }
    } catch (error) {
        console.warn('updateMenstrualCycleUseCase: ', error);
    }
};
